var map = {
	"./bedford/About": 95266,
	"./broxbourne/About": 876,
	"./darlington/About": 25178,
	"./defaults/About": 73712,
	"./demo/About": 71109,
	"./hull/About": 83833,
	"./kirklees/About": 81686,
	"./leicester/About": 82266,
	"./northgate/About": 70968,
	"./preston/About": 36883,
	"./rushcliffe/About": 65589,
	"./slough/About": 5558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32752;